<template>
    <label :for="name" class="block text-sm font-medium text-gray-700">
        {{ label }}

        <span v-if="required" class="text-red-600 text-xs">*</span>
        <slot name="field"></slot>
    </label>
    <p v-if="errors?.length" :id="name + '-error'" class="text-red-500 text-xs italic">
        <div v-for="error of errors">{{ error }}</div>
    </p>
</template>

<script>
export default {
    name: 'FieldTemplate',
    props: {
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        required: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array
        }
    }
}
</script>

<style scoped>

</style>
